import React, { Component } from "react";
import MachineSummary from "./MachineSummary";
import { Link } from "react-router-dom";

import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

class MachineList extends Component {
  render() {
    return (
      <div>
        {this.props.machines &&
          this.props.machines.map((machine) => {
            return (
              <>
                <Card className="mt-2">
                  <CardBody>
                  <Link to={"machine/" + machine.id} className="navbar-brand">
                  <Button className="btn-icon btn-3" color="primary" type="button">
                      <span className="btn-inner--icon">
                        <i className="fa fa-edit"></i>
                      </span>
                      <span className="btn-inner--text"> Edit</span>
                  </Button>
                  </Link>
                    <MachineSummary key={machine.id} machine={machine} />
                  </CardBody>
                </Card>
                
              </>
            );
          })}
      </div>
    );
  }
}

export default MachineList;
